import React from "react";
import Navbar from "./components/Navbar";
import SinglePage from "./components/SinglePage";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <Navbar />
      <SinglePage />
    </div>
  );
}

export default App;
